module.exports = __webpack_public_path__ + "img/40402379.3ad81d27.png";